import { useQuery } from "@tanstack/react-query";
import type { client } from "@duress/shared";
import { getClientSnapshot } from "@/features/clients/api";

export function useClientSnapshot(
  slug: string,
  month: string | null,
): {
  data: client.ClientSnapshot | undefined;
  isLoading: boolean;
  error: unknown;
} {
  const { data, isLoading, error } = useQuery({
    queryKey: ["client-snapshot", slug, month] as const,
    queryFn: () => getClientSnapshot(slug, month),
    enabled: Boolean(slug),
  });
  return { data, isLoading, error };
}
